
import routes from "configs/routes";
import settings from "configs/settings";

export const getRouteTitle = ( routeKey, showPostfix = false ) => {

    let _routes = {...routes};
    delete _routes.helmet;

    let title = routes.helmet.default.title;

    Object.keys(_routes).forEach( key=> {
        if( _routes[key] === routeKey ) {
            if( routes.helmet[ key ] && routes.helmet[ key ].hasOwnProperty( "title" ) ) {
                title = routes.helmet[ key ].title;
                return title;
            }
        }
    });

    if( showPostfix ) {
        return title + settings.pageTitlePostfix;
    }

    return title;
}

//! Tákolás
export const getRouteName = ( routeKey,  ) => {

    let _routes = {...routes};
    delete _routes.helmet;

    let name = routes.helmet.default.name;

    Object.keys(_routes).forEach( key=> {
        if( _routes[key] === routeKey ) {
            if( routes.helmet[ key ] && routes.helmet[ key ].hasOwnProperty( "name" ) ) {
                name = routes.helmet[ key ].name;
                return name;
            }
        }
    });

    return name;
}

export const getRouteMetaDescription = ( routeKey ) => {
    let _routes = {...routes};
    delete _routes.helmet;

    let metaDescription = routes.helmet.default.metaDescription;

    Object.keys(_routes).forEach( key => {
        if( _routes[key] === routeKey ) {
            if( routes.helmet[ key ] && routes.helmet[ key ].hasOwnProperty( "metaDescription" ) ) {
                metaDescription = routes.helmet[ key ].metaDescription;
                return metaDescription;
            }
        }
    });

    return metaDescription;
}